import MxFormErrorMessage from "@rf-l2/form/MxFormErrorMessage";
import MxFormFieldController from "@rf-l2/form/MxFormFieldController";
import MxFormInputField, {
  MxFormInputFieldProps
} from "@rf-l2/form/text-fields/MxFormInputField";
import { memo } from "react";
interface MxFormL3InputFieldProps extends MxFormInputFieldProps {
  name: string;
  withreacthookform?: 1 | 0;
}
const MxFormL3InputField = (props: MxFormL3InputFieldProps) => {
  return (
    <MxFormFieldController
      name={props.name}
      withreacthookform={props.withreacthookform}
    >
      <MxFormInputField label={props.label} {...props} />
      <MxFormErrorMessage />
    </MxFormFieldController>
  );
};

export default memo(MxFormL3InputField);
